import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

/** Aviso de cajas con el turno abierto hace más de un día (se olvidó cerrar la caja). */
export function TurnosAntiguosBanner({ terminalId, compact = false }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/cash/turnos-antiguos").then((r) => setItems(r.data?.items || [])).catch(() => {});
  }, [terminalId]);
  const lista = terminalId ? items.filter((t) => t.terminal_id === terminalId) : items;
  if (!lista.length) return null;
  return (
    <div data-testid="turnos-antiguos-banner"
      className={`bg-amber-50 border border-amber-300 text-amber-900 ${compact ? "px-4 py-1 text-xs" : "rounded-2xl px-4 py-3 text-sm mb-5"}`}>
      <p className="font-bold flex items-center gap-1.5">
        <Clock className="w-4 h-4 shrink-0" />
        {terminalId ? "Este turno lleva más de un día abierto: cierra la caja y abre uno nuevo"
          : `${lista.length} caja(s) con el turno abierto hace más de un día`}
      </p>
      {!compact && (
        <ul className="mt-1 space-y-0.5 text-xs">
          {lista.map((t) => (
            <li key={t.shift_id} data-testid={`turno-antiguo-${t.shift_id}`}>
              <b>{t.caja}</b> · {t.sucursal} · abierto el {t.fecha} {t.hora} por {t.abierto_por} · {t.dias} días
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
